<template>
    <!--
            作者：peng
            时间：2020-08-10
            描述：插件中心-高级签到-签到记录
        -->
    <div>
        <!--搜索表单-->
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="状态">
                    <el-select v-model="formInline.status" placeholder="签到状态">
                        <el-option label="全部" value="-1"></el-option>
                        <el-option v-for="(item,index) in status" :key="index" :label="item" :value="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="会员"><el-input v-model="formInline.user" placeholder="请输入昵称或手机号"></el-input></el-form-item>
                <el-form-item><el-button icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
            </el-form>
        </div>


        <div class="table-wrap">
            <el-table :data="tableData" style="width: 100%" v-loading="loading">
                <el-table-column prop="nickName" label="昵称" width="180"></el-table-column>
                <el-table-column prop="avatarUrl" label="微信头像" width="100">
                    <template slot-scope="scope">
                        <img v-img-url="scope.row.avatarUrl" width="30" height="30" />
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="手机号" width="180"></el-table-column>
                <el-table-column prop="dated_at" label="签到到期时间" width="260"></el-table-column>
                <el-table-column prop="recently" label="最近签到时间"></el-table-column>
                <el-table-column prop="count" label="累积签到次数" width="140"></el-table-column>
                <el-table-column prop="name" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button @click="editArticle(scope.row)" type="text" size="small">档案详情</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页-->
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        background
                        :current-page="curPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="totalDataNumber"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import SignadvApi from '@/api/signadv.js';
    export default {
        components: {},
        data() {
            return {
                /*分类*/
                categoryData: [],
                /*表单数据*/
                tableData: [],
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*当前编辑的对象*/
                userModel: {},
                commentData: [],
                loading: true,
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                formInline: {},
                status: ['未到期','已到期'],
            //    status_type:['0','3'],
            };
        },
        created() {
            /*获取签到档案列表*/
            this.getTableList();
        },
        methods: {

            /*获取签到档案列表*/
            getTableList() {
                let self = this;
                let Params = self.formInline;
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                SignadvApi.archiveslist(Params, true)
                    .then(data => {
                        console.log(data)
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                    })
                    .catch(error => {
                        console.log(error)
                        self.loading = false;
                    });
            },

            /* 查询 */
            onSubmit(){
                let self = this;
                self.loading = true;
                let Params = self.formInline;
                self.getTableList();
            },

            /*档案详情*/
            editArticle(row) {
                let params = row.user_id;
                this.$router.push({
                    path: '/plus/signadv/archives/detailed',
                    query: {
                        user_id: params
                    }
                });
            },

            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.loading = true;
                self.getTableList();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getTableList();
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/signadv/archives/archives.vue